import { render } from "./px-button.vue?vue&type=template&id=79471bc6&scoped=true&ts=true"
import script from "./px-button.vue?vue&type=script&lang=ts"
export * from "./px-button.vue?vue&type=script&lang=ts"

import "./px-button.vue?vue&type=style&index=0&id=79471bc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79471bc6"]])

export default __exports__